<template>
  <!-- 用户列表 -->
  <div id="agentUserList">
    <!-- 头部数据更新时间模块 -->
    <headerUpdate></headerUpdate>
    <b-card class="header-top" ref="headerH">
      <div class="header-page-title">
        <div class="title">
          {{ currentPageTitle }}
        </div>
      </div>
      <b-row>
        <b-col lg="9">
          <!--搜索uid-->
          <b-form-group class="find-middle" :label="$t('lanV4.newUid')">
            <b-form-input v-model.trim="searchUid" maxLength="15" placeholder=""></b-form-input>
          </b-form-group>
          <!-- 搜索类型 -->
          <!-- <b-form-group :label="$t('lanV4.searchType')" class="find-middle">
            <v-select
              class="find-select"
              v-model="searchType"
              :options="searchTypeArr"
            >
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
          </b-form-group> -->
          <!-- v-if="searchType.value == 0" -->
          <template>
            <!-- 邮箱/手机下拉 -->
            <b-form-group class="find-middle">
              <!-- <label>
              <el-tooltip placement="top">
                <div slot="content" :style="{ maxWidth: tipWidth }">
                  {{ $t("lanV4.ReturnedCommissionTip") }}
                </div>
                <span class="el_tooltip_bor">
                  {{ $t("lanV4.ReturnedCommission") }}</span
                >
              </el-tooltip>
            </label> -->
              <v-select class="find-select" v-model="infoType" :options="infoTypeArr">
                <div slot="no-options">{{ $t("common.noFind") }}</div>
              </v-select>
            </b-form-group>

            <!-- 邮箱/手机 搜索-->
            <b-form-group class="find-middle">
              <!-- <el-autocomplete
              class="el-input-vague"
              v-model="searchEmailPhone"
              :fetch-suggestions="querySearch"
              placeholder=""
              :trigger-on-focus="false"
              @select="handleSelectSearch"
              @input="changeDataSearch"
              maxlength="100"
            ></el-autocomplete> -->
              <b-form-input v-model.trim="searchEmailPhone" maxLength="100" placeholder=""></b-form-input>
            </b-form-group>

            <!-- 是否kyc -->
            <!-- <b-form-group :label="$t('lanV4.isKYC')" class="find-middle">
              <v-select class="find-select" v-model="isKyc" :options="isKycArr">
                <div slot="no-options">{{ $t("common.noFind") }}</div>
              </v-select>
            </b-form-group> -->
          </template>
          <!-- v-if="searchType.value == 1" -->
          <template>
            <!--PID-->
            <b-form-group class="find-middle" :label="$t('lanV4.PID')">
              <b-form-input v-model.trim="pid" maxLength="10" placeholder=""></b-form-input>
            </b-form-group>
            <!-- 是否开通合约 -->
            <b-form-group :label="$t('lanV4.isContract')" class="find-middle">
              <v-select class="find-select" v-model="isOpenContract" :options="isOpenContractArr">
                <div slot="no-options">{{ $t("common.noFind") }}</div>
              </v-select>
            </b-form-group>

            <!-- 是否入金合约 -->
            <b-form-group :label="$t('lanV4.isInContract')" class="find-middle">
              <v-select class="find-select" v-model="isInContract" :options="isInContractArr">
                <div slot="no-options">{{ $t("common.noFind") }}</div>
              </v-select>
            </b-form-group>

            <!-- 是否交易合约-->
            <b-form-group :label="$t('lanV4.isTradeContract')" class="find-middle">
              <v-select class="find-select" v-model="isTradeContract" :options="isTradeContractArr">
                <div slot="no-options">{{ $t("common.noFind") }}</div>
              </v-select>
            </b-form-group>
            <!--返佣级别-->
            <b-form-group class="find-middle" v-if="!disabledReturnLevel">
              <label>
                <el-tooltip placement="top">
                  <div slot="content" :style="{ maxWidth: tipWidth }">
                    {{ $t("lanV4.ReturnedCommissionLevelTip") }}
                  </div>
                  <span class="el_tooltip_bor">
                    {{ $t("lanV4.ReturnedCommissionLevel") }}</span>
                </el-tooltip>
              </label>
              <v-select class="find-select" v-model="level" :options="levelArray">
                <div slot="no-options">{{ $t("common.noFind") }}</div>
              </v-select>
            </b-form-group>
            <!-- 注册时间 -->
            <b-form-group :label="$t('lanV4.Registrationtime')" class="find-middle">
              <el-date-picker v-model="dateArray" unlink-panels type="datetimerange" value-format="timestamp"
                range-separator="-" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"
                @change="handleChangeDate" :clearable="true" :picker-options="pickerOptions">
              </el-date-picker>
            </b-form-group>
            <!-- 开通合约时间 -->
            <b-form-group :label="$t('lanV4.openContractTime')" class="find-middle">
              <el-date-picker v-model="dateArrayTwo" unlink-panels type="datetimerange" value-format="timestamp"
                range-separator="-" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"
                @change="handleChangeDateTwo" :clearable="true" :picker-options="pickerOptions">
              </el-date-picker>
            </b-form-group>
          </template>
        </b-col>
        <b-col lg="3" class="header-right-btn">
          <div class="find-middle find-btnBox">
            <b-button variant="primary" @click="query">
              <!-- <svg class="icon icon-14 icon-search" aria-hidden="true">
                    <use xlink:href="#icon-v4_17"></use>
                  </svg> -->
              {{ $t("common.search") }}</b-button>
            <b-button variant="light" @click="reset">
              <!-- <svg class="icon icon-14 icon-reset" aria-hidden="true">
                    <use xlink:href="#icon-v4_3"></use>
                  </svg> -->
              {{ $t("common.reset") }}</b-button>
          </div>
        </b-col>
      </b-row>
      <!-- 头部分割线 -->
      <div class="header-top-bottom-bor"></div>
    </b-card>
    <b-card class="table-card">
      <div slot="header">
        <div class="table-title float-left">
          <!-- 数据总览 标题 -->
          <!-- {{ $t("lanV4.Datascreening") }} -->
          <span v-if="pages.total > 0">
            {{ $t("el.pagination.total", { total: pages.total }) }}
          </span>
        </div>
        <!-- <v-page
              class="float-left"
              v-if="pages.total > 0"
              :total-rows="pages.total"
              :perPage="pages.size"
              :pageOptions="pages.options"
              :currentPage="pages.page"
              @initialize="pageChange"
              layout="total,sizes"
            >
            </v-page> -->
        <!-- 导出 -->
        <b-button v-if="pages.total > 0" class="float-right btn-export" variant="light"
          :class="!isexportIng ? 'lodingSattus' : ''" @click="exports">
          <svg class="icon icon-16" aria-hidden="true">
            <use xlink:href="#icon-v4_6_h"></use>
          </svg>
          <span v-if="isDownLoadIng">{{  $t("common.exportIng")}}</span>
          <span v-else>{{ exportButtonText }}</span>
          <svg v-if="!isexportIng||isDownLoadIng" class="icon icon-20 btn-loading" aria-hidden="true">
            <use xlink:href="#icon-v4_loading"></use>
          </svg>
        </b-button>
      </div>
      <b-row>
        <b-col class="table-section">
          <el-table :height="$store.state.baseData.tableH" class="table-container" :data="tableList"
            @sort-change="sortChanged" :cell-class-name="addEnClass"
            :default-sort="{ prop: 'totalAmount', order: 'descending' }">
            <template slot="empty">
              <load-skeleton v-show="loading" :columns="6" :rows="10" :haveLeftNumber="false"></load-skeleton>
              <h4 class="common-table-noData" v-show="!loading">
                <img src="../../assets/images/v4_nodata.png" alt="" />
                <div class="noData-text">
                  {{ $t("common.noData") }}
                </div>
              </h4>
            </template>

            <!--  序号 -->
            <el-table-column prop="sort" align="left" :label="$t('common.sort')">
            </el-table-column>

            <!--  uid-->
            <el-table-column prop="uid" align="right" :label="$t('lanV4.newUid')" width="150">
            </el-table-column>
            <!--  手机/邮箱-->
            <el-table-column prop="info" align="right" :label="$t('lanV4.agentEmaiPhone')" width="200">
              <template slot-scope="scope">
                <div>
                  <div>{{ scope.row.phone }}</div>
                  <div>{{ scope.row.email }}</div>
                </div>
              </template>
            </el-table-column>
            <!--  pid -->
            <el-table-column prop="pid" align="right" width="150">
              <template slot-scope="scope" slot="header">
                <el-tooltip placement="top">
                  <div slot="content" style="max-width: 200px">
                    <!-- 直属上级UID -->
                    {{ $t("lanV4.pidTip2") }}
                  </div>
                  <span> {{ $t("lanV4.PID") }}</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span class="enNum">
                  {{ scope.row.pid }}
                </span>
              </template>
            </el-table-column>

            <!-- 返佣级别 -->
            <el-table-column v-if="!disabledReturnLevel" prop="returnLevel" :label="$t('lanV4.ReturnedCommissionLevel')"
              align="right" width="150">
            </el-table-column>

            <!-- 地区 -->
            <el-table-column prop="country" :label="$t('lanV4.Region')" align="right" width="160">
            </el-table-column>

            <!--  是否kyc -->
            <el-table-column prop="kyc" align="right" :label="$t('lanV4.isKYC')">
            </el-table-column>

            <!--  是否开通合约 -->
            <el-table-column prop="contract" align="right" :label="$t('lanV4.isContract')" width="150">
            </el-table-column>

            <!--  是否入金合约 -->
            <el-table-column prop="inContract" align="right" :label="$t('lanV4.isInContract')" width="150">
            </el-table-column>

            <!--  是否交易合约 -->
            <el-table-column prop="tradeContract" align="right" :label="$t('lanV4.isTradeContract')" width="150">
            </el-table-column>

            <!--  开通合约时间-->
            <el-table-column prop="coTime" align="right" :label="$t('lanV4.openContractTime')" width="200">
            </el-table-column>

            <!--  注册时间-->
            <el-table-column prop="ctime" align="right" :label="$t('lanV4.Registrationtime')" width="200">
            </el-table-column>
          </el-table>
        </b-col>
      </b-row>
      <b-row class="mar-t-20">
        <b-col>
          <v-page v-if="pages.total > 0" :total-rows="pages.total" :perPage="pages.size" :pageOptions="pages.options"
            :currentPage="pages.page" @initialize="pageChange"></v-page>
        </b-col>
      </b-row>
    </b-card>

    <!-- 导出10000条提示 -->
    <b-modal v-model="exportsModalShow" :title="$t('exportsModal.text1')" size="md" centered scrollable
      no-close-on-backdrop id="code-modal">
      <div class="body-content">
        <div class="expor-number-tip">
          {{
            $t("exportsModal.text2", { pagesTotal: pages.total, maxNum: 50000 })
          }}
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
          $t("common.cancel")
        }}</b-button>
        <b-button class="coustom-btn" variant="primary" @click="exports('true')"
          :class="!isexportIng ? 'lodingSattus' : ''">
          <template v-if="!isexportIng">
            {{ $t("common.exportIng") }}
          </template>
          <template v-else>
            <!-- 继续导出 -->
            {{ $t("exportsModal.text3") }}
          </template>
        </b-button>
      </template>
    </b-modal>
    <!--最新导出loading -->
    <b-modal v-model="downLoadIsShow" size="md" :title="exportText" centered scrollable no-close-on-backdrop
      @hide="onReset">
      <div class="fileName">
        <span>{{ fileName }}</span>
        <svg class="icon btn-loading" aria-hidden="true" style="font-size: 34px" v-if="isDownLoadIng">
          <use xlink:href="#icon-v4_loading_chart"></use>
        </svg>
      </div>
      <template v-slot:modal-footer>
        <b-button class="coustom-btn" :variant="dowDisbaled ? 'secondary' : 'primary'" @click="downloadFile">
          {{ $t("common.download") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import commonMixin from "@/mixin/common/commonMixin";
import { fixD, fixInput, formatTime } from "@/apis/newmethods";
import headerUpdate from "./components/headerUpdate.vue";
import { setCookie, getCookie,removeCookie } from "@/apis/cookie";
export default {
  name: "agentUserList",
  mixins: [commonMixin],
  components: {
    headerUpdate,
  },
  data() {
    return {
      searchUid: null, // uid
      searchType: null,
      infoType: null, //查询类型 0:电话 1:邮箱
      searchEmailPhone: "", //模糊查询邮箱手机号
      restaurants: [], //模糊搜索返回值
      pid: null, //pid
      level: null, //返佣级别
      levelArray: [], //返佣级别下拉
      isKyc: null, //是否kyc
      isOpenContract: null, //是否开通合约
      isInContract: null, //是否入金合约
      isTradeContract: null, //是否交易合约
      dateArray: [new Date().getTime() - 86400000 * 30, new Date().getTime()],
      beginDate: null,
      endDate: null,
      dateArrayTwo: [
        // new Date().getTime() - 86400000 * 30,
        // new Date().getTime(),
      ],
      beginDateTwo: null,
      endDateTwo: null,
      // 当天之后的时间无法选择
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > window.Date.now();
        },
      },

      pages: {
        page: 1, // 当前页数
        size: 10, // 页数大小
        options: [10, 40, 60, 100], // 页数大小选择
        total: 0, // 总页数
      },
      notData: true,
      loading: true,
      tableList: [],
      modalShow: false,
      isexportIng: true,
      sortBy: null, //预先排序的字段
      sortDesc: true, //预先降序
      sortName: "totalAmount", //默认排序字段
      sortSet: 1, //默认倒序
      //导出
      fileName: '',
      timer: null,
      dowDisbaled: true,
      fileUrl: null,
      activeFileId: getCookie('isShowDownLoadDialogAgentUserList') ? getCookie('isShowDownLoadDialogAgentUserList') : null,
      downLoadIsShow: getCookie('isShowDownLoadDialogAgentUserList') ? false : false,
      isDownLoadIng: getCookie('isShowDownLoadDialogAgentUserList') ? true : false,
    };
  },
  computed: {
    exportText() {
      return this.$t("common.exportTit");
    },
    //搜索类型
    searchTypeArr() {
      return [
        {
          label: this.$t("lanV4.agentSpot"), //现货
          value: 0,
        },
        {
          label: this.$t("lanV4.agentFutures"), //合约
          value: 1,
        },
      ];
    },
    // 邮箱,手机
    infoTypeArr() {
      return [
        {
          label: this.$t("lanV4.agentEmail"), //邮箱
          value: 0,
        },
        {
          label: this.$t("lanV4.agentPhone"), //手机
          value: 1,
        },
      ];
    },
    //是否kyc
    isKycArr() {
      return [
        {
          label: this.$t("common.all"), //全部
          value: null,
        },
        {
          label: this.$t("lanV4.yes"), //是
          value: 1,
        },
        {
          label: this.$t("lanV4.no"), //否
          value: 0,
        },
      ];
    },
    //是否开通合约
    isOpenContractArr() {
      return [
        {
          label: this.$t("common.all"), //全部
          value: null,
        },
        {
          label: this.$t("lanV4.yes"), //是
          value: 1,
        },
        {
          label: this.$t("lanV4.no"), //否
          value: 0,
        },
      ];
    },
    //是否入金合约
    isInContractArr() {
      return [
        {
          label: this.$t("common.all"), //全部
          value: null,
        },
        {
          label: this.$t("lanV4.yes"), //是
          value: 1,
        },
        {
          label: this.$t("lanV4.no"), //否
          value: 0,
        },
      ];
    },
    //是否交易合约
    isTradeContractArr() {
      return [
        {
          label: this.$t("common.all"), //全部
          value: null,
        },
        {
          label: this.$t("lanV4.yes"), //是
          value: 1,
        },
        {
          label: this.$t("lanV4.no"), //否
          value: 0,
        },
      ];
    },

    exportButtonText() {
      if (!this.isexportIng) {
        return this.$t("common.exportIng"); // '正在导出'
      }
      return this.$t("common.export");
    },
  },
  watch: {
    pid(v) {
      if (v) {
        this.$nextTick(() => {
          this.pid = fixInput(v, 0, { num: 1 });
        });
      }
    },
    searchUid(v) {
      if (v) {
        this.$nextTick(() => {
          this.searchUid = fixInput(v, 0, { num: 1 });
        });
      }
    },
  },
  created() {
    this.handleChangeDate();
    this.handleChangeDateTwo();
    this.getReturnLevel();
    this.searchType = this.searchTypeArr[0];
    this.level = this.levelArray[0];
    this.infoType = this.infoTypeArr[0];
    this.isKyc = this.isKycArr[0];
    this.isOpenContract = this.isOpenContractArr[0];
    this.isInContract = this.isInContractArr[0];
    this.isTradeContract = this.isTradeContractArr[0];
    this.getData();
    if (this.activeFileId) {
      this.getexportinfo();
    }
  },
  methods: {
    // 模糊搜索
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      cb(results);
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1
        );
      };
    },
    //@select 点击选中触发
    handleSelectSearch(item) {
      this.name = item.value;
      this.select = item.value;
      this.getnumber();
    },
    //@input 在 Input 值改变时触发
    changeDataSearch(value) {
      if (value != "") {
        this.getSelectSearchData();
      } else {
        this.image = "";
        this.select = "";
      }
    },
    // 获取模糊搜索接口
    getSelectSearchData() {
      this.$http({
        url: this.$store.state.url.agent.email,
        params: {
          type: this.infoType ? this.infoType.value : null,
          name: this.name,
        },
        // method: "get",
        // apiType: "fe-json-server",
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          this.restaurants = data.restaurants.map((item) => {
            return {
              value: item.value,
            };
          });
        }
      });
    },

    // 选择时间
    handleChangeDate() {
      this.beginDate = this.dateArray[0];
      this.endDate = this.dateArray[1];
    },
    // 选择时间
    handleChangeDateTwo() {
      this.beginDateTwo = this.dateArrayTwo[0];
      this.endDateTwo = this.dateArrayTwo[1];

    },
    // 英文数字字体
    addEnClass({ row, column }) {
      switch (column.property) {
        case "uid":
          return "enNum";
        case "pid":
          return "enNum";
        case "tradeAmount":
          return "enNum";
        case "fee":
          return "enNum";
        case "returnAmount":
          return "enNum";
      }
    },
    // 排序变化
    sortChanged(ctx) {
      switch (ctx.prop) {
        case "tradeAmount":
          this.sortName = "tradeAmount";
          break;
        case "fee":
          this.sortName = "fee";
          break;
        case "returnAmount":
          this.sortName = "returnAmount";
          break;
      }
      this.sortSet = ctx.order === "descending" ? 1 : 0;
      this.getData();
    },

    // 获取返佣级别下拉
    getReturnLevel() {
      this.$http({
        url: this.$store.state.url.agent.level_list,
        params: {
          hasSelfReturn: 0, //不包含自返佣
        },
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          let arr = [];
          arr.push({ label: this.$t("common.all"), value: null });
          if (data) {
            data.levelArray.map((item) => {
              arr.push({ label: item.levelName, value: item.level });
            });
            this.levelArray = arr;
            this.level = arr[0];
          }
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },

    // 搜索
    query() {
      this.pages.page = 1;
      this.loading = true;
      this.getData();
    },
    // 重置
    reset() {
      this.searchUid = null;
      this.searchType = this.searchTypeArr[0];
      this.infoType = this.infoTypeArr[0];
      this.searchEmailPhone = null;
      this.pid = null;
      this.level = this.levelArray[0];
      this.isKyc = this.isKycArr[0];
      this.isOpenContract = this.isOpenContractArr[0];
      this.isInContract = this.isInContractArr[0];
      this.isTradeContract = this.isTradeContractArr[0];
      this.dateArray = [
        new Date().getTime() - 86400000 * 30,
        new Date().getTime(),
      ];
      this.dateArrayTwo = [
        // new Date().getTime() - 86400000 * 30,
        // new Date().getTime(),
      ];
      this.handleChangeDate();
      this.handleChangeDateTwo();
    },
    // 获取数据列表
    getData() {
      this.loading = true;
      this.tableList = [];
      const paramsData = {
        startTime: this.dateArray ? this.beginDate : null,
        endTime: this.dateArray ? this.endDate : null,
        coStartTime: this.dateArrayTwo && this.dateArrayTwo[0] ? this.beginDateTwo : null,
        coEndTime: this.dateArrayTwo && this.dateArrayTwo[1] ? this.endDateTwo : null,
        uid: this.searchUid,
        pid: this.pid,
        // conditionType: this.searchType ? this.searchType.value : null, //搜索类型 0现货 1合约
        // conditionType: null,
        phone: this.infoType.value ? this.searchEmailPhone : null,
        email: !this.infoType.value ? this.searchEmailPhone : null,
        returnLevel: this.level ? this.level.value : null,
        kyc: this.isKyc ? this.isKyc.value : null,
        contract: this.isOpenContract ? this.isOpenContract.value : null,
        coInStatus: this.isInContract ? this.isInContract.value : null, // 是否入金
        coTradeStatus: this.isTradeContract ? this.isTradeContract.value : null, // 是交易合约
        pageNum: this.pages.page,
        pageSize: this.pages.size,
        isExport: 0,
      };
      this.$http({
        url: this.$store.state.url.agent.user_list,
        params: paramsData,
        // method: "get",
        // apiType: "fe-json-server",
      })
        .then(({ data, code, msg }) => {
          this.loading = false;
          if (data && code.toString() === "0") {
            this.setData(data.pageInfo);
          } else {
            this.$bus.$emit("alert", { type: "error", message: msg });
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    setData(datas) {
      const { total, rows } = datas;
      this.pages.total = total ? total : 0;
      let arr = [];
      if (rows && rows.length) {
        rows.map((item, index) => {
          arr.push({
            sort: (this.pages.page - 1) * this.pages.size + (index + 1), //序号
            uid: item.uid,
            info: item.info, // 邮箱或手机
            phone: item.phone, //手机
            email: item.email, //邮箱
            pid: item.pid == 0 ? "--" : item.pid,
            returnLevel: item.returnLevel, //返佣级别
            country: item.country ? item.country : "--", //地区
            kyc: item.kyc,
            contract: item.contract,
            inContract: item.inContract,
            tradeContract: item.tradeContract,
            coTime:
              item.coTime && item.coTime != "946656000000"
                ? formatTime(item.coTime)
                : "--", //开通合约时间
            ctime: item.ctime ? formatTime(item.ctime) : "--", //注册时间
          });
        });
      }
      if (arr.length === 0) {
        this.notData = true;
      }
      this.tableList = arr;
    },
    // 导出
    exports(istrue) {
      if (
        istrue !== "true" &&
        this.pages.total &&
        Number(this.pages.total) > 50000
      ) {
        this.exportsModalShow = true;
      } else {
        if (!this.isexportIng) return;
        this.isexportIng = false;
        const paramsData = {
          startTime: this.dateArray ? this.beginDate : null,
          endTime: this.dateArray ? this.endDate : null,
          coStartTime: this.dateArrayTwo && this.dateArrayTwo[0] ? this.beginDateTwo : null,
          coEndTime: this.dateArrayTwo && this.dateArrayTwo[1] ? this.endDateTwo : null,
          uid: this.searchUid,
          pid: this.pid,
          // conditionType: this.searchType ? this.searchType.value : null, //搜索类型 0现货 1合约
          // conditionType: null, //搜索类型 0现货 1合约
          phone: this.infoType.value ? this.searchEmailPhone : null,
          email: !this.infoType.value ? this.searchEmailPhone : null,
          returnLevel: this.level ? this.level.value : null,
          kyc: this.isKyc ? this.isKyc.value : null,
          contract: this.isOpenContract ? this.isOpenContract.value : null,
          pageNum: this.pages.page,
          pageSize: 50000,
          isExport: 1,
          coInStatus: this.isInContract ? this.isInContract.value : null, // 是否入金
          coTradeStatus: this.isTradeContract ? this.isTradeContract.value : null, // 是交易合约
        };

        this.outExcel(
          this.$store.state.url.agent.user_list,
          paramsData,
          "increment-api"
        ).then((datas) => {
          if (datas.code === "0") {
            // this.$bus.$emit("alert", {
            //   type: "success",
            //   message: this.$t("common.exportSuccess"),
            // }); // 导出成功
            // this.exportsModalShow = false;

            this.activeFileId = datas.data.id;
            this.getexportinfo();
            // setTimeout(() => {
            //   // this.isexportIng = true;
            // }, 500);
          } else {
            this.$bus.$emit("alert", {
              type: "error",
              message: this.$t("common.exportError"),
            }); // 导出失败
          }
        });
      }
    },
    getexportinfo() {
      this.downLoadIsShow = false;
      this.isDownLoadIng = true;
      this.dowDisbaled = true;
      setCookie('isShowDownLoadDialogAgentUserList', this.activeFileId);
      this.exportsShowDialog();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.exportsShowDialog();
      }, 3000)
    },

    exportsShowDialog() {
      const paramsData = {
        id: this.activeFileId
      };
      this.outExcel(
        this.$store.state.url.agent.get_export_info,
        paramsData,
        "increment-api"
      ).then((datas) => {
        if (datas.code === "0") {
          if (!datas.data) {
            this.onReset();
            clearInterval(this.timer);
          }
          this.fileName = datas.data.name;
          if (datas.data.status === 0) {
            clearInterval(this.timer);
            this.dowDisbaled = false;
            this.isDownLoadIng = false;
            this.fileUrl = datas.data.url;
            setTimeout(() => {
              this.isexportIng = true;
              this.downloadFile()
            }, 500);
          }
        } else {
          this.$bus.$emit("alert", {
            type: "error",
            message: this.$t("common.exportError"),
          }); // 导出失败
          this.onReset();
        }
      });

    },
    downloadFile() {
      if (this.fileUrl && !this.dowDisbaled) {
        const link = document.createElement('a');
        link.href = this.fileUrl;
        link.download = this.fileName; // 这里可以指定下载的文件名
        // 触发点击事件下载文件
        link.click();
        this.$bus.$emit("alert", {
          type: "success",
          message: this.$t("common.exportSuccess"),
        }); // 导出成功
        this.exportsModalShow = false;
        this.onReset();
      }
    },
    onReset() {
      this.exportsModalShow = false;
      clearInterval(this.timer);
      this.downLoadIsShow = false;
      this.dowDisbaled = true;
      this.fileUrl = '';
      this.isDownLoadIng = false;
      this.isexportIng = true
      removeCookie('isShowDownLoadDialogAgentUserList');
    },
    // 分页
    pageChange(data) {
      const { page, pageSize } = data;
      this.pages.page = page;
      this.pages.size = pageSize;
      const v = "page";
      this.getData(v);
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null; // 清除引用，帮助垃圾回收
    }
  }
};
</script>

<style lang="scss">
#agentUserList {
  .custom-control {
    top: 5px !important;
  }
}
</style>